import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgDashboardNewApplication({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.62 2a2 2 0 012 2v2.85a4.83 4.83 0 00-4.9 6.74H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6.62zm1.52 5.8a3.86 3.86 0 110 7.72 3.86 3.86 0 010-7.73zm-.1 1.69c-.3.04-.53.3-.53.62v.92H10.5a.64.64 0 00-.53.63v.09c.05.3.3.53.62.53h.92v1.02c.05.3.31.53.63.53h.1c.3-.05.53-.31.53-.63v-.92h1.01c.3-.05.53-.31.53-.62v-.1a.63.63 0 00-.63-.53h-.92V10a.63.63 0 00-.62-.53zM4.6 5.29h5.45c.36 0 .65-.27.65-.59 0-.32-.3-.58-.65-.58H4.59c-.37 0-.66.26-.66.58 0 .32.3.58.66.58zm-.08 2.7h2.41a.58.58 0 000-1.16H4.51a.58.58 0 100 1.16z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgDashboardNewApplication.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgDashboardNewApplication.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgDashboardNewApplication svgRef={ref} {...props} />
));
export default ForwardRef;
